import type { BaseBusinessInfoModel, BasePersonalInfoModel } from '../common/models/base/base-personal-info.model';

export default function fullName<T extends BasePersonalInfoModel>(model: T): string {
  return model.firstName + ' ' + model.lastName;
}

export function displayName<T extends BaseBusinessInfoModel>(model: T): string {
  const businessName = model.businessName?.trim();
  return businessName?.length ? businessName : fullName(model);
}
